import styled from 'styled-components'

export const PanelContainer = styled.div`
  position: fixed;
  top: ${({ theme }) => theme.layout.appHeaderHeight};
  right: 0;
  width: 360px;
  height: calc(100vh - ${({ theme }) => theme.layout.appHeaderHeight});
  background: white;
  /* box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1); */
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 999;

  &.open {
    transform: translateX(0);
  }

  @media (max-width: 768px) {
    width: 100%;
    top: ${({ theme }) => theme.layout.appHeaderHeight};
    height: calc(100vh - ${({ theme }) => theme.layout.appHeaderHeight});
    z-index: 1000;
  }
`

export const PanelHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
`

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b6b6b;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    color: #1a1a1a;
  }
`

export const ActiveLayerDisplay = styled.div`
  padding: 12px 16px;
  background: #e6f7fc;
  border-bottom: 1px solid #e5e5e5;
`

export const ActiveLayerTop = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`

export const ActiveLayerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  width: 50%;
`

export const ActiveLayerIcon = styled.div<{ color: string }>`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color}1A;
  color: ${(props) => props.color};
  flex-shrink: 0;
`

export const ActiveLayerInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const ActiveLayerLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #007aa6;
  margin-bottom: 3px;
  opacity: 0.7;
`

export const ActiveLayerName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
`

export const ActiveLayerSource = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ActiveLayerActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`

export const LayerOffButton = styled.button`
  padding: 6px 10px;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #6b6b6b;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #f5f5f5;
    border-color: #999;
    color: #ff3b30;
  }
`

export const TransparencyControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TransparencyValue = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #6b6b6b;
  min-width: 32px;
  text-align: right;
`

export const TransparencySlider = styled.input`
  width: 80px;
  height: 4px;
  appearance: none;
  -webkit-appearance: none;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    background: #00ade6;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.2s;

    &:hover {
      transform: scale(1.2);
    }
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    background: #00ade6;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    border: none;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.2);
    }
  }
`

export const FavoritesSection = styled.div`
  padding: 12px 20px;
  background: white;
  border-bottom: 1px solid #e5e5e5;
`

export const FavoriteTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999;
  margin-bottom: 8px;
`

export const FavoriteLayers = styled.div`
  display: flex;
  gap: 6px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const FavoriteLayer = styled.button`
  padding: 3px 8px;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 11px;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: #f5f5f5;
    border-color: #999;
  }

  &.active {
    background: #e6f7fc;
    border-color: #00ade6;
    color: #00ade6;
  }
`

export const RemoveButton = styled.span`
  margin-left: 4px;
  font-size: 14px;
  line-height: 1;
  opacity: 0.7;
  cursor: pointer;
  padding-bottom: 2px;
`

export const SearchSection = styled.div`
  padding: 16px 20px 8px 20px;
  background: white;
  position: sticky;
  top: 0;
  z-index: 1;
`

export const SearchWrapper = styled.div`
  position: relative;
  margin-top: 12px;
  margin-bottom: 12px;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 40px 10px 16px;
  background: #f5f5f5;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: #1a1a1a;
  transition: all 0.2s;

  &:focus {
    outline: none;
    background: white;
    border-color: #00ade6;
    box-shadow: 0 0 0 3px rgba(0, 173, 230, 0.1);
  }

  &::placeholder {
    color: #999;
  }
`

export const SearchIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
`

export const LayerContent = styled.div`
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #e5e5e5 transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e5e5e5;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`

export const LayerCategory = styled.div`
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`

export const CategoryHeader = styled.div`
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;

  &:hover {
    background: #fafafa;
  }
`

export const CategoryTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const CategoryIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CategoryCount = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #999;
  margin-left: 4px;
`

export const CategoryToggle = styled.div`
  width: 20px;
  height: 20px;
  color: #6b6b6b;
  transition: transform 0.2s;

  &.collapsed {
    transform: rotate(-90deg);
  }
`

export const CategoryContent = styled.div`
  max-height: 1000px;
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .collapsed & {
    max-height: 0;
  }
`

export const LayerItem = styled.div`
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;

  &:hover {
    background: #fafafa;
  }

  &.active {
    background: #e6f7fc;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: #00ade6;
    }
  }
`

export const LayerInfo = styled.div`
  flex: 1;
  min-width: 0;
  margin-right: 12px;
`

export const LayerName = styled.div`
  font-size: 13px;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
`

export const LayerSource = styled.div`
  font-size: 11px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LayerPreview = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color}1A;
  color: ${(props) => props.color};
`

export const LayerInfoButton = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  transition: all 0.2s;
  opacity: 0;

  ${LayerItem}:hover & {
    opacity: 1;
  }

  &:hover {
    background: #f5f5f5;
    color: #1a1a1a;
  }
`

export const FavoriteButton = styled.button<{ $isFavorite: boolean }>`
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $isFavorite }) => ($isFavorite ? '#FFB800' : '#999')};
  transition: all 0.2s;
  opacity: ${({ $isFavorite }) => ($isFavorite ? 1 : 0)};
  margin-right: 4px;

  ${LayerItem}:hover & {
    opacity: 1;
  }

  &:hover {
    background: ${({ $isFavorite }) => ($isFavorite ? '#FFF3D6' : '#f5f5f5')};
    color: #ffb800;
  }

  svg {
    fill: ${({ $isFavorite }) => ($isFavorite ? '#FFB800' : 'none')};
    stroke: ${({ $isFavorite }) => ($isFavorite ? '#FFB800' : '#999')};
    stroke-width: ${({ $isFavorite }) => ($isFavorite ? '0' : '2')};

    &:hover {
      fill: ${({ $isFavorite }) => ($isFavorite ? '#FFB800' : 'none')};
      stroke: #ffb800;
    }
  }
`

// WMS Layer specific styles
export const WMSLayerItem = styled(LayerItem)`
  gap: 12px;
`

export const WMSLayerCheckbox = styled.div`
  display: flex;
  align-items: center;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`

export const LayerLegendPreview = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 4px;
  background: #f8f8f8;
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  color: #999;
`

export const LoadingText = styled.span`
  font-size: 13px;
`

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  color: #ff3b30;
  background: #fff5f5;
  border-radius: 6px;
  margin: 12px 20px;
  font-size: 13px;
`

export const ErrorText = styled.span`
  flex: 1;
`
